interface RankTabsProps {
  tabs: { key: string; label: string; desc: string }[];
  value: string;
  onChange: (key: string) => void;
}

export default function RankTabs({ tabs, value, onChange }: RankTabsProps) {
  return (
    <div className="rounded-card border border-background-200/80 bg-background-50 p-1">
      <div className="flex flex-col gap-1 sm:flex-row">
        {tabs.map((tab) => {
          const active = tab.key === value;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              aria-pressed={active}
              className={`flex-1 rounded-xl px-4 py-3 text-left transition-colors duration-200 ${
                active
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="block text-sm font-medium">{tab.label}</span>
              <span
                className={`mt-0.5 block text-xs ${
                  active ? "text-background-50/70" : "text-foreground-500"
                }`}
              >
                {tab.desc}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}